import { render, staticRenderFns } from "./ProductsAndExtrasTab.vue?vue&type=template&id=6ae433c2&lang=pug&"
import script from "./ProductsAndExtrasTab.vue?vue&type=script&lang=js&"
export * from "./ProductsAndExtrasTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports